import React from "react";
import ProductShopButton from "../../ProductName/ProductShopButton";
import ProductName from "../../ProductName/ProductName";
import "./YtThumbnail.css";
import "../../GeneralPostTag/ShopCardAlignment.css";
import Caption from "../../FeedPost/PlatformPosts/Caption";
import PostInfo from "../../FeedPost/PostInfo/PostInfo";
import track, { TRACKING_TYPES } from "../../../Utils/SupabaseServices/Track";
import { useLocation } from "react-router-dom";
import { MdOutlineDragIndicator } from "react-icons/md";
import { FaThumbtack } from "react-icons/fa";
import { BsPinAngleFill } from "react-icons/bs";
const IndividualYoutubePostTag = ({
  link,
  handleRedirect,
  bgColor,
  contentShape,
  handleClick,
  redirectUrl,
  source,
  shoppableContent,
  from,
  showDragHandle = false,
  pinnedPostIds = [],
  isDashboard = true,
  designTokens,
  /** False when a parent carousel already renders ProductShopButton below the slider. */
  showShopButton = true,
}: any) => {
  const location = useLocation();
  const containerRef = React.useRef<HTMLDivElement>(null);
  const [isIndividual, setIsIndividual] = React.useState(false);
  const [inWebsiteTemplate, setInWebsiteTemplate] = React.useState(false);
  const isPinned = Array.isArray(pinnedPostIds)
    ? pinnedPostIds.includes(link?.post_id)
    : false;
  // Loaders pass "sq" or boolean true. Legacy LiB uses from="landing-page".
  // Website template shells keep their own tile CSS, so square is not applied there.
  const isSquareMedia =
    contentShape === "sq" ||
    contentShape === "square" ||
    contentShape === true;

  const renderPinnedBadge = () =>
    isPinned && source !== "edit" ? (
      <div
        className="pinned-badge"
        aria-label="Pinned post"
        style={{ right: isIndividual ? 0 : 16 }}
      >
        <BsPinAngleFill />
      </div>
    ) : null;

  React.useLayoutEffect(() => {
    const node = containerRef.current;
    if (!node) return;
    setIsIndividual(!!node.closest(".individual-outer-container"));
    setInWebsiteTemplate(
      !!node.closest(
        ".tpl-stayuptodate-embed, .tpl-link-in-bio-carousel, .tpl-template-feed-grid, .master-template-link-in-bio-feed, .mte-tpl-page, .mte-root--we, [data-template-shell='true']"
      )
    );
  }, []);

  function handleShop(
    postId: string,
    media_url: string,
    platform: any,
    name: any
  ) {
    // Prefer parent handleRedirect (FeedControls / StayUpToDate) when present so
    // embed clicks use `/embed/{username}` and component identity.
    if (typeof handleRedirect === "function") {
      handleRedirect(
        postId,
        media_url,
        platform,
        name,
        undefined,
        true,
        from,
      );
      return;
    }
    track("Redirect to shop link", TRACKING_TYPES.EVENT, {
      pathname: location.pathname,
      details: { post_id: postId, media_url: media_url, platform, name },
      user_id: link.user_id,
    });
  }
  function handleTagged(
    postId: string,
    media_url: string,
    platform: any,
    name: string
  ) {
    if (typeof handleRedirect === "function") {
      handleRedirect(
        postId,
        media_url,
        platform,
        name,
        undefined,
        false,
        from,
      );
      return;
    }
    track("Redirect to tagged link", TRACKING_TYPES.EVENT, {
      pathname: location.pathname,
      details: { post_id: postId, media_url: media_url, platform, name },
      user_id: link.user_id,
    });
  }
  
  return (
    <div
      ref={containerRef}
      style={{ position: "relative", color: "inherit" }}
      className={`creator-post-stack${
        source === "content-bank" ? " yt-content-bank-feed" : ""
      }`}
    >
      <a
        href={redirectUrl || undefined}
        target="_blank"
        onClick={handleClick}
        style={{ position: "relative", display: "block", textDecoration: "none", color: "inherit", fontFamily: designTokens?.secondaryFontFamily }}
        rel="noreferrer"
        className={source === "content-bank" ? "yt-content-bank-feed" : undefined}
      >
      {renderPinnedBadge()}
      <div
        className={`yt-canva-card${
          from === "website-template" || from === "landing-page"
            ? " yt-template-website-card"
            : ""
        }${
          isSquareMedia && from !== "website-template" && !inWebsiteTemplate
            ? " square-wrapper"
            : ""
        }${source === "feed" ? " feed-ytthumbnail" : ""}${
          source === "content-bank" ? " yt-content-bank-card" : ""
        }`}
        style={{
          // boxShadow: bgColor && `0px 0.325rem 0px 0px ${bgColor}`,
          textDecoration: "none",
          // Same as landing/website/individual: spacing from stack/PostInfo only.
          // Search feed (`source`/`from` = feed) must not add a YouTube-only % margin.
          marginBottom:
            from === "website-template" ||
            from === "landing-page" ||
            from === "feed" ||
            source === "feed" ||
            isIndividual
              ? 0
              : "4%",
          position: showDragHandle ? "relative" : undefined,
        }}
        data-content-shape={contentShape}
        data-source={source}
      >
        {showDragHandle && (
          <div
            className="drag-handle-overlay"
            style={{
              position: "absolute",
              top: 6,
              right: 6,
              zIndex: 3,
              background: "rgba(0,0,0,0.55)",
              color: "#fff",
              borderRadius: "0.35rem",
              padding: "4px 5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "grab",
              userSelect: "none",
            }}
            title="Drag to reorder"
            aria-label="Drag to reorder"
          >
            <MdOutlineDragIndicator size={16} />
          </div>
        )}
        <div className="yt-title" style={{color: "white", fontFamily: designTokens?.secondaryFontFamily}}>{link.caption}</div>
        <img
          src={(() => {
            const media = String(link.media_url || "").trim();
            const thumb = String(link.thumbnail || "").trim();
            const looksLikeVideoFile =
              /\.(mp4|mov|webm|m3u8|m4v)(\?|#|$)/i.test(media);
            return looksLikeVideoFile ? thumb || media : media || thumb;
          })()}
          alt={link.caption || "YouTube Video"}
          className="yt-thumbnail"
        />
        <div className="yt-date-label"style={{color:"white", fontFamily: designTokens?.secondaryFontFamily}} >
          {link.post_date
            ? new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              }).format(new Date(link.post_date))
            : ""}
          <br />
          YouTube Video
        </div>
      </div>
      </a>
      
      <React.Fragment>
        {source === "feed" ? (
          <>
            <PostInfo
              username={link.username}
              user_id={link.user_id}
              showAsAd={link.show_ad}
              post_date={link.post_date}
              permalink={link.permalink}
              shop_link={link.shop_link}
              tagged_link={link.tagged_link}
              external_link={link.external_link}
              post_id={link.post_id}
              handleRedirect={handleRedirect}
              handleShop={handleShop}
              handleTagged={handleTagged}
              platform={link.platform}
              media_url={link.media_url}
              shoppableContent={shoppableContent ?? link.shoppableContent}
              name={link.name}
              overrideDesignTokens={designTokens}
            />
            <Caption caption={link.caption} designTokens={designTokens} />
          </>
        ) : source === "content-bank" ? null : (
          <>
           {!source && from !== "website-template" && (
              <ProductName type={link.type} post={link} designTokens={designTokens} />
            )}
            {/* Hide ProductName when called from AddedContentTypePosts (edit mode) */}
           
            {showShopButton &&
              from !== "content-bank" &&
              from !== "preview" &&
              source !== "edit" && (
                <span className="yt-shop-btn-wrap">
                  <ProductShopButton
                    isLinks={link}
                    isIndividual={isIndividual}
                    type={link.type}
                    post={link}
                    // Real <a>: CTA sits outside the media link (asLink={false} was dead).
                    asLink={true}
                    isDashboard={isDashboard}
                    designTokens={designTokens}
                    onBeforeNavigate={() =>
                      handleShop(
                        link?.post_id,
                        link?.media_url,
                        link?.platform,
                        link?.product_name || link?.name,
                      )
                    }
                  />
                </span>
              )}
          </>
        )}
      </React.Fragment>
    </div>
  );
};

export default IndividualYoutubePostTag;
